module.exports = __webpack_public_path__ + "static/img/visionPic3.ea3ad52.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/visionPic3.jpg
// module id = ipdE
// module chunks = 0